import { addressClass as AC, addressType as AT, type FieldType, type IClientAddress } from '@/interfaces'

export class ClientAddress implements IClientAddress {
	[key: string]: FieldType
	id: string
	active: boolean
	address1?: string
	address2?: string
	address3?: string
	city?: string
	state?: string
	zip?: string
	country?: string
	unit: string
	type: AT
	addressClass: AC = AC.Other
	notes: string
	constructor({
		id = '',
		address1 = '',
		address2 = '',
		address3 = '',
		city = '',
		state = '',
		zip = '',
		country = '',
		unit = '',
		active = true,
		notes = '',
		type = AT.BillTo,
		addressClass = AC.Other
	}: Partial<IClientAddress> = {}) {
		this.id = id
		this.address1 = address1
		this.address2 = address2
		this.address3 = address3
		this.city = city
		this.state = state
		this.zip = zip
		this.country = country
		this.unit = unit
		this.active = active
		this.notes = notes
		this.type = type
		this.addressClass = addressClass
	}
	public get isPrimary(): boolean {
		return this.addressClass === AC.Primary
	}
	public set isPrimary(value: boolean) {
		this.addressClass = value ? AC.Primary : AC.Other
	}
}
